import { render, staticRenderFns } from "./AddictiveStuffEdit.vue?vue&type=template&id=243a3afd&scoped=true&"
import script from "./AddictiveStuffEdit.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243a3afd",
  null
  
)

export default component.exports